import { useWorkspace } from '@/features/workspaces/hooks';
import { CampaignResponse } from '@/services/endpoints/campaigns/types';
import { useGetAudienceDistributionChannelsQuery } from '@/services/endpoints/distributionChannels';
import { FC } from 'react';
import { CampaignDetailsSection } from '../CampaignDetailsSection';
import { ConnectedDestinationsTable } from './ConnectedDestinationsTable';

type ConnectedDestinationsSectionProps = {
  campaign: CampaignResponse | undefined;
};

export const ConnectedDestinationsSection: FC<ConnectedDestinationsSectionProps> = ({ campaign }) => {
  const workspace = useWorkspace();

  const { data: destinations, isLoading: isDestinationsLoading } = useGetAudienceDistributionChannelsQuery(
    {
      workspaceId: workspace.id,
      audienceId: campaign.audienceId,
    },
    {
      skip: !campaign.audienceId,
    }
  );

  return (
    <CampaignDetailsSection header='connectedDestinations'>
      <ConnectedDestinationsTable campaign={campaign} connectedDestinations={destinations} isLoading={isDestinationsLoading} />
    </CampaignDetailsSection>
  );
};
